import { useContext } from 'react';
import AccountPickerContext from '../contexts/AccountPickerContext';

const useCurrentAccountId = () => {
  const { selectedAccountId } = useContext(AccountPickerContext);
  return selectedAccountId;
};

export default useCurrentAccountId;
